export default __webpack_public_path__ + "static/media/WNLProtoLap1.fa0f59c1.png";